/**
 * wishlist.js – onlinefliesen.de
 * Einbau in theme.liquid vor </body>:
 *
 *   {{ 'wishlist.css' | asset_url | stylesheet_tag }}
 *   <script src="{{ 'wishlist.js' | asset_url }}" defer></script>
 *   <script>
 *     document.addEventListener('DOMContentLoaded', function () {
 *       Wishlist.init({
 *         {%- if customer -%}
 *         customerId: {{ customer.id | json }},
 *         metafieldData: {{ customer.metafields.wishlist.items.value | default: 'null' }},
 *         {%- endif -%}
 *       });
 *     });
 *   </script>
 */

(function () {
  'use strict';

  var STORAGE_KEY = 'wl_items';
  var MAX_ITEMS   = 100;
  var PAGE_HANDLE = 'favoriten';

  var _items = [];

  /* ── HTML-Escaping ───────────────────────────────────── */
  // Verhindert, dass Sonderzeichen in Produkttiteln (z.B. Anführungszeichen bei
  // Zoll-Angaben wie 12") Attribute/Tags aufbrechen und das Karten-Layout zerschiessen.
  function _esc(str) {
    return String(str == null ? '' : str)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#39;');
  }

  /* ── Storage ─────────────────────────────────────────── */
  function _load() {
    try {
      var raw = localStorage.getItem(STORAGE_KEY);
      _items = raw ? JSON.parse(raw) : [];
      if (!Array.isArray(_items)) _items = [];
    } catch (e) { _items = []; }
  }

  function _save() {
    try { localStorage.setItem(STORAGE_KEY, JSON.stringify(_items)); } catch (e) {}
    _updateUI();
  }

  function _idx(id) {
    id = String(id);
    for (var i = 0; i < _items.length; i++) {
      if (String(_items[i].id) === id) return i;
    }
    return -1;
  }

  /* ── Preis-Hilfsfunktionen ───────────────────────────── */
  function _isZeroPrice(raw) {
    if (!raw) return true;
    var n = parseFloat(raw.replace(/[^0-9,\.]/g, '').replace(',', '.'));
    return isNaN(n) || n === 0;
  }

  function _formatPrice(raw) {
    if (!raw) return '';
    if (raw.indexOf('€') !== -1 || raw.indexOf('/') !== -1 || raw.indexOf('EUR') !== -1) return raw;
    var n = parseInt(raw, 10);
    if (isNaN(n)) return raw;
    return (n / 100).toLocaleString('de-DE', { style: 'currency', currency: 'EUR' });
  }

  /* ── Preise per API nachladen (alle Einträge) ──────── */
  function _refreshPrices(callback) {
    var toUpdate = _items.filter(function (item) { return !!item.handle; });
    if (toUpdate.length === 0) { callback(); return; }

    var pending = toUpdate.length;
    var changed = false;

    toUpdate.forEach(function (item) {
      fetch('/products/' + item.handle + '.js')
        .then(function (r) { return r.json(); })
        .then(function (p) {
          var variant = null;
          for (var vi = 0; vi < p.variants.length; vi++) {
            if (p.variants[vi].price > 0) { variant = p.variants[vi]; break; }
          }
          if (variant) {
            var price;
            var up  = variant.unit_price  || p.unit_price;
            var upm = variant.unit_price_measurement || p.unit_price_measurement;
            if (up && upm) {
              var unit = (upm.reference_unit || upm.quantity_unit || 'm²');
              price = (up / 100).toLocaleString('de-DE', { style: 'currency', currency: 'EUR' }) + ' / ' + unit;
            } else {
              price = (variant.price / 100).toLocaleString('de-DE', { style: 'currency', currency: 'EUR' });
            }
            var si = _idx(item.id);
            if (si !== -1 && _items[si].price !== price) {
              _items[si].price = price;
              _items[si].variantId = variant.id; // Variant-ID für ATC mitspeichern
              changed = true;
            }
          }
        })
        .catch(function () {})
        .finally(function () {
          pending--;
          if (pending === 0) {
            if (changed) {
              try { localStorage.setItem(STORAGE_KEY, JSON.stringify(_items)); } catch (e) {}
            }
            callback();
          }
        });
    });
  }

  /* ── In den Warenkorb ────────────────────────────────── */
  function _addToCart(btn, variantId) {
    if (!variantId) {
      // Fallback: Produkt-Seite öffnen wenn keine Variant-ID bekannt
      var url = btn.getAttribute('data-product-url');
      if (url) window.location.href = url;
      return;
    }

    btn.classList.add('is-loading');

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: variantId, quantity: 1 })
    })
      .then(function (r) {
        if (!r.ok) throw new Error('ATC failed');
        return r.json();
      })
      .then(function () {
        btn.classList.remove('is-loading');
        btn.classList.add('is-added');
        var span = btn.querySelector('span');
        if (span) span.textContent = 'Hinzugefügt';

        // Warenkorb-Counter im Theme aktualisieren (Standard Shopify-Event)
        document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
        fetch('/cart.js')
          .then(function (r) { return r.json(); })
          .then(function (cart) {
            var counters = document.querySelectorAll('[data-cart-count], .cart-count, #CartCount, .header__cart-count');
            counters.forEach(function (el) { el.textContent = cart.item_count; });
          }).catch(function () {});

        setTimeout(function () {
          btn.classList.remove('is-added');
          var span2 = btn.querySelector('span');
          if (span2) span2.textContent = 'In den Warenkorb';
        }, 2500);
      })
      .catch(function () {
        btn.classList.remove('is-loading');
        // Fallback: Produktseite öffnen
        var url = btn.getAttribute('data-product-url');
        if (url) window.location.href = url;
      });
  }

  /* ── UI ──────────────────────────────────────────────── */
  function _updateUI() {
    var count = _items.length;

    document.querySelectorAll('[data-wishlist-btn]').forEach(function (btn) {
      var pid = btn.getAttribute('data-product-id');
      if (!pid) return;
      var on = _idx(pid) !== -1;
      btn.classList.toggle('is-active', on);
      btn.setAttribute('aria-pressed', on ? 'true' : 'false');
    });

    document.querySelectorAll('[data-wishlist-header-icon]').forEach(function (el) {
      el.classList.toggle('has-items', count > 0);
    });

    document.querySelectorAll('[data-wishlist-count]').forEach(function (el) {
      el.textContent = count;
      el.style.display = count > 0 ? 'flex' : 'none';
    });

    _renderPage();
  }

  /* ── Favoriten-Seite ─────────────────────────────────── */
  function _isWishlistPage() {
    return window.location.pathname === '/pages/' + PAGE_HANDLE;
  }

  function _renderPage() {
    var mount = document.getElementById('wl-mount');
    if (!mount) return;

    var count = _items.length;

    if (count === 0) {
      mount.innerHTML =
        '<div class="wl-empty">'
        + '<div class="wl-empty-icon"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"><path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z"/></svg></div>'
        + '<p class="wl-empty-title">Noch keine Favoriten</p>'
        + '<p class="wl-empty-sub">Entdecke unsere Kollektionen und markiere deine Lieblingsprodukte.</p>'
        + '<a href="/collections/all" class="wl-empty-cta">Jetzt entdecken</a>'
        + '</div>';
      return;
    }

    var cards = _items.map(function (item) {
      var safeUrl   = _esc(item.url || '#');
      var safeTitle = _esc(item.title);
      var safeImage = _esc(item.image);
      var safeId    = _esc(item.id);

      var img = item.image
        ? '<img class="wl-card-img" src="' + safeImage + '" alt="' + safeTitle + '" loading="lazy">'
        : '<div class="wl-card-img-placeholder"></div>';
      var price = item.price
        ? '<span style="font-size:12px;font-weight:600;white-space:nowrap;flex-shrink:0;color:#0a0a0a;">' + _esc(_formatPrice(item.price)) + '</span>'
        : '';

      // ATC Button – mit Variant-ID falls vorhanden
      var variantId = item.variantId ? _esc(item.variantId) : '';
      var atcBtn =
        '<button class="wl-card-atc"'
        + ' data-variant-id="' + variantId + '"'
        + ' data-product-url="' + safeUrl + '"'
        + ' aria-label="In den Warenkorb">'
        + '<svg viewBox="0 0 24 24"><line x1="12" y1="5" x2="12" y2="19"/><line x1="5" y1="12" x2="19" y2="12"/></svg>'
        + '<span>In den Warenkorb</span>'
        + '</button>';

      return '<div class="wl-card">'
        + '<a class="wl-card-img-wrap" href="' + safeUrl + '">' + img + '</a>'
        + '<div class="wl-card-info"><a class="wl-card-title" href="' + safeUrl + '">' + safeTitle + '</a>' + price + '</div>'
        + '<div class="wl-card-actions">'
        + '<button class="wl-card-remove" data-remove="' + safeId + '" aria-label="Entfernen">'
        + '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>'
        + '</button>'
        + atcBtn
        + '</div>'
        + '</div>';
    }).join('');

    mount.innerHTML =
      '<div class="wl-toolbar">'
      + '<p class="wl-page-count">' + (count === 1 ? '1 Produkt' : count + ' Produkte') + '</p>'
      + '<button class="wl-clear-btn" id="wl-clear-btn">Alle entfernen</button>'
      + '</div>'
      + '<div class="wl-grid">' + cards + '</div>';

    var clearBtn = document.getElementById('wl-clear-btn');
    if (clearBtn) {
      clearBtn.addEventListener('click', function () {
        if (confirm('Alle Favoriten entfernen?')) Wishlist.clear();
      });
    }
  }

  function _initPage() {
    if (!_isWishlistPage()) return;

    var targets = [
      document.querySelector('.page-width'),
      document.querySelector('.shopify-section'),
      document.querySelector('main'),
      document.querySelector('#MainContent'),
      document.querySelector('.main-content'),
    ];

    var container = null;
    for (var i = 0; i < targets.length; i++) {
      if (targets[i]) { container = targets[i]; break; }
    }

    if (!container) return;

    var h1 = container.querySelector('h1');
    if (h1) h1.textContent = 'Meine Favoriten';

    var rte = container.querySelector('.rte, .page-content, [class*="page__content"], [class*="article__content"]');
    if (rte) rte.style.display = 'none';

    if (!document.getElementById('wl-mount')) {
      var mount = document.createElement('div');
      mount.id = 'wl-mount';
      mount.className = 'wl-page';
      container.appendChild(mount);
    }

    // Klick-Delegation: Entfernen + ATC
    document.addEventListener('click', function (e) {
      // Entfernen-Button
      var removeBtn = e.target.closest('[data-remove]');
      if (removeBtn) {
        Wishlist.remove(removeBtn.getAttribute('data-remove'));
        return;
      }

      // In den Warenkorb
      var atcBtn = e.target.closest('.wl-card-atc');
      if (atcBtn) {
        var variantId = atcBtn.getAttribute('data-variant-id');
        _addToCart(atcBtn, variantId || null);
      }
    });

    // Preise nachladen falls 0, dann rendern
    _refreshPrices(function () {
      _renderPage();
    });
  }

  /* ── Klick-Handler (global, für Herz-Buttons überall) ── */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-wishlist-btn]');
    if (btn) {
      e.preventDefault();
      e.stopPropagation();
      var id = btn.getAttribute('data-product-id');
      if (!id) return;
      if (_idx(id) !== -1) {
        Wishlist.remove(id);
      } else {
        Wishlist.add({
          id:     id,
          title:  btn.getAttribute('data-product-title')  || '',
          handle: btn.getAttribute('data-product-handle') || '',
          price:  btn.getAttribute('data-product-price')  || '',
          image:  btn.getAttribute('data-product-image')  || '',
          url:    btn.getAttribute('data-product-url')    || ''
        });
      }
      return;
    }

    var rem = e.target.closest('[data-remove]');
    if (rem) Wishlist.remove(rem.getAttribute('data-remove'));
  });

  /* ── Öffentliche API ─────────────────────────────────── */
  var Wishlist = {

    init: function (opts) {
      opts = opts || {};
      _load();

      if (opts.metafieldData) {
        try {
          var srv = JSON.parse(opts.metafieldData);
          if (Array.isArray(srv) && srv.length > 0) {
            var merged = srv.slice();
            _items.forEach(function (loc) {
              if (!merged.find(function (s) { return String(s.id) === String(loc.id); }))
                merged.push(loc);
            });
            _items = merged.slice(0, MAX_ITEMS);
            _save();
            return;
          }
        } catch (e) {}
      }

      _initPage();
      _updateUI();
    },

    add: function (p) {
      if (!p || !p.id || _idx(p.id) !== -1 || _items.length >= MAX_ITEMS) return;
      _items.unshift({ id: String(p.id), title: p.title || '', handle: p.handle || '', price: p.price || '', image: p.image || '', url: p.url || '' });
      _save();
    },

    remove: function (id) {
      var i = _idx(id);
      if (i === -1) return;
      _items.splice(i, 1);
      _save();
    },

    has: function (id) { return _idx(id) !== -1; },
    getAll: function () { return _items.slice(); },
    count: function () { return _items.length; },
    clear: function () { _items = []; _save(); }
  };

  window.Wishlist = Wishlist;
})();